import { CountDownProgressProps } from '../CountDownProgress/CountDownProgress';

export function calculateStartAndEndTimes(
  utcDateString: string,
  isAbandonedCartEnabled = false
): CountDownProgressProps {
  // Converte a string UTC para um objeto Date
  const currentUtcDate = new Date(utcDateString);

  // Calcula o offset de timezone local em minutos
  const timezoneOffset = currentUtcDate.getTimezoneOffset();
  const offsetInMilliseconds = timezoneOffset * 60 * 1000;
  // Converte a data UTC para o horário local
  const localDate = new Date(currentUtcDate.getTime() - offsetInMilliseconds);

  const startTime: Date = localDate;

  if (isAbandonedCartEnabled) {
    const abandonedCartLimitHours = 48;
    const endTime = new Date(localDate);
    endTime.setHours(endTime.getHours() + abandonedCartLimitHours);

    return { startTime, endTime };
  }

  const cutOffHour = 16;
  const endOfDayHour = 23;
  const endOfDayMinute = 59;

  let endTime: Date;

  if (localDate.getHours() >= cutOffHour) {
    endTime = new Date(localDate);
    endTime.setHours(endOfDayHour);
    endTime.setMinutes(endOfDayMinute);
    endTime.setSeconds(0);
  } else {
    endTime = new Date(localDate);
    endTime.setHours(endTime.getHours() + 8);
    endTime.setMinutes(endTime.getMinutes());
    endTime.setSeconds(endTime.getSeconds());
  }

  return { startTime, endTime };
}
